import React from 'react';
import { NavLink } from 'react-router-dom';

import Const from '../../util/Constants';
import Util from '../../util/Util';

class SettingsItem extends React.Component {
  render() {
    if(!Util.isAllow(this.props.model.permission, Const.PermView)) return null;
    
    const name = this.props.name ? this.props.name : this.props.model.model_name;
    const link = this.props.link;
    const text = this.props.text;
    const icon = this.props.icon;
    return <li> <NavLink to={link}> {icon} {name} </NavLink> <p>{text}</p> </li>;
  }
}
export default SettingsItem;